import { useParams } from 'react-router';

import { Posts } from '@/models/posts';
import { LabelsCard } from '@/views/labels/components/LabelsCard';

interface CreatorPostLabelsPorps {
  postData: Posts.Details;
}

const CreatorPostLabels = ({ postData }: CreatorPostLabelsPorps) => {
  const postId = Number(useParams().postId);

  if (!postData) return <></>;
  return <LabelsCard postId={postId} labels={postData.labels ?? []} />;
};

export default CreatorPostLabels;
